module.exports = __webpack_public_path__ + "img/shop-figma.a01eeb82.svg";